import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {XW2GameMode, XwaysHoarder2} from "../XwaysHoarder2";
import {XwaysHoarder2GameAssets} from "../XwaysHoarder2GameAssets";
import {gsap, Linear} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SpineGSAPWrapper} from "../utils/SpineGSAPWrapper";
import {CustomWiggle} from "gsap/dist/CustomWiggle";


export class BackgroundElements extends PIXI.Container implements StageLayer {
    private transitionUnder: PIXI.spine.Spine;

    private currentMode: GameMode;

    private mainReelBackPlate: PIXI.Sprite;
    private fsReelBackPlate: PIXI.Sprite;
    private allBackPlates: PIXI.Sprite [] = [];


    constructor() {
        super();
        this.name = "backgroundElements";
        this.init();
    }

    private init() {
        this.currentMode = GameMode.NORMAL;


        this.mainReelBackPlate = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures(XwaysHoarder2GameAssets.BASE_BACK_PLATE)[0]);
        this.mainReelBackPlate.position.set(360, 388);
        this.mainReelBackPlate.anchor.set(0.5, 0.5);
        this.mainReelBackPlate.name = "basegame backPlate";
        //this.mainReelBg.alpha = 0;

        this.fsReelBackPlate = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures(XwaysHoarder2GameAssets.FS_BACK_PLATE)[0]);
        this.fsReelBackPlate.position.set(360, 390);
        this.fsReelBackPlate.anchor.set(0.5, 0.5);
        this.fsReelBackPlate.name = "bonus backPlate";
        this.fsReelBackPlate.alpha = 0;
        this.allBackPlates.push(this.mainReelBackPlate,this.fsReelBackPlate);

        this.transitionUnder = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.BG_TRANSITION_UNDER));
        this.transitionUnder.position.set(345, 360);
        this.transitionUnder.visible = false;
        this.addChild(this.transitionUnder);
        console.log("TRANSITION UNDER ANIMATIONS", this.transitionUnder.spineData.animations);

        this.addChild(this.mainReelBackPlate);
        this.addChild(this.fsReelBackPlate);

        this.onOrientationChanged();
        this.onResize();

        //this.playTransitionUnder();
        //this.setBackground(XW2GameMode.SUPER_FREESPIN);
        //this.playIdleLoop(XW2GameMode.NORMAL);
    }

    private playTransitionUnder(animName:string = "Transitions/MG FS"): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this.transitionUnder.visible = true;
        });
        tl.add(SpineGSAPWrapper.createTimelineForAnimation(this.transitionUnder, 0, animName,false));



        return tl;
    }

    private tranistionSpineMgToSfs(currentBG: PIXI.Sprite, nextBG: PIXI.Sprite): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        return tl;
    }

    private tranistionSpineFsToSfs(currentBG: PIXI.Sprite, nextBG: PIXI.Sprite): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        return tl;
    }

    public stopLoop(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {
            this.transitionUnder.state.setEmptyAnimation(0, 0);
        });

        return tl;
    }

    public playGameIntroSpine(): gsap.core.Timeline {
        /*
             Animation {name: 'Intro/GameIntro', timelines: Array(16), duration: 4.400000095367432}
         */

        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(this.playTransitionUnder("Intro/GameIntro"));
        tl.add(this.playIdleLoop(XW2GameMode.NORMAL));

        return tl;
    }

    public playIdleLoop(gameMode: XW2GameMode): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        /*
            Animation {name: 'Idles/Binge Idle', timelines: Array(53), duration: 3.700000047683716}
            Animation {name: 'Idles/FS Idle', timelines: Array(84), duration: 6.6666998863220215}
            Animation {name: 'Idles/MainGame Idle', timelines: Array(110), duration: 10}
            Animation {name: 'Idles/SFS Idle', timelines: Array(80), duration: 6.6666998863220215}
     */
        /*tl.add(() => {
            this.transitionUnder.state.setEmptyAnimation(0,0);
        });*/

        switch(gameMode) {
            case XW2GameMode.NORMAL:
                tl.add(() => {
                    this.transitionUnder.visible = true;
                    this.transitionUnder.autoUpdate = true;
                    this.transitionUnder.state.setAnimation(0, "Idles/MainGame Idle", true);
                });
                break;
            case XW2GameMode.FREESPIN:
                tl.add(() => {
                    this.transitionUnder.visible = true;
                    this.transitionUnder.autoUpdate = true;
                    this.transitionUnder.state.setAnimation(0, "Idles/FS Idle", true);
                });
                break;
            case XW2GameMode.SUPER_FREESPIN:
                tl.add(() => {
                    this.transitionUnder.visible = true;
                    this.transitionUnder.autoUpdate = true;
                    this.transitionUnder.state.setAnimation(0, "Idles/SFS Idle", true);
                });
                break;
            case XW2GameMode.BINGE_SPINS:
                tl.add(() => {
                    this.transitionUnder.visible = true;
                    this.transitionUnder.autoUpdate = true;
                    this.transitionUnder.state.setAnimation(0, "Idles/Binge Idle", true);
                });
                break;
        }

        return tl;
    }

    public makeTransition(gameMode: XW2GameMode, fromMode: XW2GameMode): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();


        switch (gameMode) {
            case XW2GameMode.NORMAL:

                if (fromMode === XW2GameMode.SUPER_FREESPIN) {
                    if(XwaysHoarder2.model.data.currentFSLevel < 4){
                        // current: sfs, new: base
                        tl.add(this.transitionSpineSfsToMg());
                    }else{
                        // current: binge, new: base
                        tl.add(this.transitionSpineBingeToMg());
                    }
                } else {
                    // current: fs, new: base
                    if(XwaysHoarder2.model.data.currentFSLevel < 4) {
                        tl.add(this.transitionSpineFsToMg());
                    }
                    else {
                        tl.add(this.transitionSpineBingeToMg());
                    }
                }

                break;
            case XW2GameMode.RESPIN: break;
            case XW2GameMode.FREESPIN:
                tl.add(this.transitionSpineMgToFs());
                break;
            case XW2GameMode.SUPER_FREESPIN:
                // TODO: add from mode
                tl.add(this.transitionSpineMgToSfs());
                break;
            case XW2GameMode.BINGE_SPINS:
                if(fromMode === XW2GameMode.SUPER_FREESPIN) {
                    tl.add(this.transitionSpineSfsToBinge());
                }
                else {
                    tl.add(this.transitionSpineFsToBinge());
                }

                break;

        }

        return tl;
    }


    public setBackground(gameMode: XW2GameMode, fromMode: XW2GameMode, restore: boolean = false): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        if (restore) {

            this.allBackPlates.forEach((sprite) => {
                sprite.alpha = 0;
                sprite.visible = false;
            });

            switch (gameMode) {
                case XW2GameMode.NORMAL:

                    this.mainReelBackPlate.visible = true;
                    this.mainReelBackPlate.alpha = 1;
                    break;
                case XW2GameMode.RESPIN:

                    this.mainReelBackPlate.visible = true;
                    this.mainReelBackPlate.alpha = 1;
                    break;
                case XW2GameMode.FREESPIN:

                    this.fsReelBackPlate.visible = true;
                    this.fsReelBackPlate.alpha = 1;
                    break;
                case XW2GameMode.SUPER_FREESPIN:

                    this.fsReelBackPlate.visible = true;
                    this.fsReelBackPlate.alpha = 1;
                    break;
                case XW2GameMode.BINGE_SPINS:

                    this.fsReelBackPlate.visible = true;
                    this.fsReelBackPlate.alpha = 1;
                    break;
            }
        } else {
            switch (gameMode) {
                case XW2GameMode.NORMAL:
                    if (fromMode === XW2GameMode.SUPER_FREESPIN) {
                        if(XwaysHoarder2.model.data.nextFSLevel<4){
                            //tl.add(this.transitionDownwardsBeforeOutro(this.sFreespinBackground, this.baseGame));
                        }else{
                            //tl.add(this.transitionUpwardsPostIntro(this.bingeSpins, this.baseGame));
                        }
                    } else {
                        //tl.add(this.transitionDownwardsBeforeOutro(this.freespinBg, this.baseGame));
                    }
                    break;
                case XW2GameMode.RESPIN:

                    break;
                case XW2GameMode.FREESPIN:

                    //tl.add(this.transitionUpwardsPostIntro(this.baseGame, this.freespinBg));
                    break;
                case XW2GameMode.SUPER_FREESPIN:
                    //tl.add(this.transitionUpwardsPostIntro(this.baseGame, this.sFreespinBackground));
                    break;
                case XW2GameMode.BINGE_SPINS:
                    if (fromMode === GameMode.NORMAL || fromMode === XW2GameMode.RESPIN) {
                        // TODO: Possible? Do FS to Binge atm
                        //tl.add(this.transitionUpwardsPostIntro(this.baseGame, this.bingeSpins));
                    } else if (fromMode === GameMode.FREESPIN) {
                        //tl.add(this.transitionDownwardsBeforeOutro(this.freespinBg, this.bingeSpins));
                    } else {
                        //tl.add(this.transitionDownwardsBeforeOutro(this.sFreespinBackground, this.bingeSpins));
                    }

                    break;
                default:
                    break;
            }
        }

        return tl;
    }

    public onOrientationChanged() {

    }

    public onResize() {

        if (NolimitApplication.isLandscape) {
            this.fsReelBackPlate.scale.set(1, 1);
            this.mainReelBackPlate.scale.set(1, 1);
            this.transitionUnder.scale.set(1, 1);
        } else {
            this.fsReelBackPlate.scale.set(0.75, 0.75);
            this.mainReelBackPlate.scale.set(0.75, 0.75);
            this.transitionUnder.scale.set(0.75, 0.75);
        }

    }

    public restore(mode: XW2GameMode, nextMode: XW2GameMode): void {
        this.currentMode = mode;
        this.setBackground(mode, nextMode, true);
    }

    /*
               Animation {name: 'Idles/Binge Idle', timelines: Array(8), duration: 0}
               Animation {name: 'Idles/FS Idle', timelines: Array(10), duration: 6.6666998863220215}
               Animation {name: 'Idles/MainGame Idle', timelines: Array(10), duration: 10}
               Animation {name: 'Idles/SFS Idle', timelines: Array(10), duration: 6.6666998863220215}
               Animation {name: 'Intro/GameIntro', timelines: Array(16), duration: 4.400000095367432}
               Animation {name: 'Transitions/Binge MG', timelines: Array(18), duration: 5.8333001136779785}
               Animation {name: 'Transitions/FS BINGE', timelines: Array(18), duration: 5.8333001136779785}
               Animation {name: 'Transitions/FS MG', timelines: Array(19), duration: 5.8333001136779785}
               Animation {name: 'Transitions/MG FS', timelines: Array(19), duration: 5.8333001136779785}
               Animation {name: 'Transitions/MG SFS', timelines: Array(20), duration: 5.8333001136779785}
               Animation {name: 'Transitions/SFS BINGE', timelines: Array(19), duration: 5.8333001136779785}
               Animation {name: 'Transitions/SFS MG', timelines: Array(20), duration: 5.8333001136779785}
        */

    public transitionSpineFsToMg(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {

            this.mainReelBackPlate.visible = true;
            this.mainReelBackPlate.alpha = 1;

            this.fsReelBackPlate.visible = false;
            this.fsReelBackPlate.alpha = 0;
        });
        tl.add(this.playTransitionUnder("Transitions/FS MG"));


        return tl;
    }

    public transitionSpineSfsToMg(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {

            this.mainReelBackPlate.visible = true;
            this.mainReelBackPlate.alpha = 1;

            this.fsReelBackPlate.visible = false;
            this.fsReelBackPlate.alpha = 0;
        });
        tl.add(this.playTransitionUnder("Transitions/SFS MG"));


        return tl;
    }

    public transitionSpineBingeToMg(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {

            this.mainReelBackPlate.visible = false;
            this.mainReelBackPlate.alpha = 0;

            this.fsReelBackPlate.visible = true;
            this.fsReelBackPlate.alpha = 1;
        });
        tl.add(this.playTransitionUnder("Transitions/Binge MG"));


        return tl;
    }


    public transitionSpineMgToFs(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {

            this.mainReelBackPlate.visible = false;
            this.mainReelBackPlate.alpha = 0;

            this.fsReelBackPlate.visible = true;
            this.fsReelBackPlate.alpha = 1;
        });
        tl.add(this.playTransitionUnder("Transitions/MG FS"));


        return tl;
    }

    public transitionSpineMgToSfs(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {

            this.mainReelBackPlate.visible = false;
            this.mainReelBackPlate.alpha = 0;

            this.fsReelBackPlate.visible = true;
            this.fsReelBackPlate.alpha = 1;
        });
        tl.add(this.playTransitionUnder("Transitions/MG SFS"));



        return tl;
    }

    public transitionSpineFsToBinge(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {

            this.mainReelBackPlate.visible = false;
            this.mainReelBackPlate.alpha = 0;

            this.fsReelBackPlate.visible = true;
            this.fsReelBackPlate.alpha = 1;
        });
        tl.add(this.playTransitionUnder("Transitions/FS BINGE"));



        return tl;
    }

    public transitionSpineSfsToBinge(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(() => {

            this.mainReelBackPlate.visible = false;
            this.mainReelBackPlate.alpha = 0;

            this.fsReelBackPlate.visible = true;
            this.fsReelBackPlate.alpha = 1;
        });
        tl.add(this.playTransitionUnder("Transitions/SFS BINGE"));


        return tl;
    }


    public backPlateTransition(nextMode: string): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        if (nextMode == GameMode.NORMAL) {
            tl.add(() => {
                this.mainReelBackPlate.visible = true;
                this.fsReelBackPlate.visible = false;
                this.fsReelBackPlate.alpha = 0;
            }, 0)
            tl.to(this.mainReelBackPlate, {duration: 0.0001, alpha: 1});
        } else {
            tl.add(() => {
                this.fsReelBackPlate.visible = true;
                this.mainReelBackPlate.visible = false;
                this.mainReelBackPlate.alpha = 0;
            })
            tl.to(this.fsReelBackPlate, {duration: 0.001, alpha: 1});
        }

        return tl;

    }

    public screenShake(dur: number, wiggles: number = 40, isVertical: boolean, movepos?: number): gsap.core.Timeline {
        let moveXVal: number = movepos ? movepos : 5,
            moveYVal: number = movepos ? movepos : 5;
        let wiggleTl: gsap.core.Timeline = gsap.timeline(),
            x: string = Math.random() > 0.5 ? `-=${moveXVal}` : `+=${moveXVal}`,
            y: string = Math.random() > 0.5 ? `-=${moveYVal}` : `-=${moveYVal}`;

        const shakeWiggle = CustomWiggle.create("shakeWiggle", {
            wiggles: wiggles,
            amplitudeEase: Linear.easeNone,
            timingEase: Linear.easeNone
        });
        if (!isVertical) {
            wiggleTl.to(this, {
                duration: dur,
                x: x,
                ease: shakeWiggle
            }, 0);
        }
        wiggleTl.to(this, {
            duration: dur,
            y: y,
            ease: shakeWiggle
        }, 0);
        wiggleTl.to(this, {
            x: 0,
            y: 0,
            duration: 0.01
        });

        return wiggleTl;
    }
}